/**
 * @method getIsElementOutsideViewport
 *
 * @param {object} elementBounding dimension attributes for the element that is being checked - use element.getBoundingClientRect()
 * @param {object} frame the frame element, from DocumentValuesContext
 *
 * @returns {Boolean} is the element outside of the current viewport?
 */
const getIsElementOutsideViewport = (elementBounding, frame) => {
  const elementTop = Math.round(elementBounding.top);
  const elementBottom = Math.round(elementBounding.bottom);

  const visibleAreaTop = frame.parentElement.parentElement.scrollTop;
  const visibleAreaBottom =
    visibleAreaTop + frame.parentElement.parentElement.clientHeight;

  if (
    elementBounding.top >= 0 &&
    elementBounding.left >= 0 &&
    elementTop >= visibleAreaTop &&
    elementBottom <= visibleAreaBottom
  ) {
    // Element is in the viewport!
    return false;
  }
  // 'Element is NOT in the viewport!
  return true;
};

export default getIsElementOutsideViewport;
